import styled from "styled-components";

export const LandingPageForm = styled("form")`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;
